import { config } from '../config';

const getAuthToken = () => {
  return localStorage.getItem('idToken');
};

export const connectorTypeSettingsService = {
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.v2_connector_type_id) params.append('v2_connector_type_id', filters.v2_connector_type_id);
    if (filters.name) params.append('name', filters.name);
    if (filters.limit) params.append('limit', filters.limit);

    const queryString = params.toString();
    const url = `${config.apiBaseUrl}/admin/connector-type-settings${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to fetch connector type settings');
    }

    return response.json();
  },

  get: async (id) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-type-settings/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to fetch connector type setting');
    }

    return response.json();
  },

  create: async (data) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-type-settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to create connector type setting');
    }

    return response.json();
  },

  update: async (id, data) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-type-settings/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to update connector type setting');
    }

    return response.json();
  },

  delete: async (id) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/connector-type-settings/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': getAuthToken()
      }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error?.message || 'Failed to delete connector type setting');
    }

    return response.json();
  }
};
